import { FC, ComponentProps, createElement } from 'react';

type IHtmlRenderProps = ComponentProps<any> & {
    tag?: string;
    html: string | undefined | false;
};

export const HtmlRender: FC<IHtmlRenderProps> = props => {
    const { tag = 'div', html, ...rest } = props;
    if (!html) {
        return null;
    }
    return createElement(tag, {
        ...rest,
        dangerouslySetInnerHTML: { __html: html }
    })
};
